import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from "rxjs/Observable";

@Injectable()
export class ParticipateService {


  constructor(private http: HttpClient) {
  }

  createParticipation(participation): Observable<any> {
    const url = environment.main_url + 'pc/create-purchase-participation';
    const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    return this.http.post(url, participation, httpOptions);
  }

  getParticipationStatus(payment_id): Observable<any> {
    const url = environment.main_url + 'pc/check-purchase-participation?payment_id=' + payment_id;
    return this.http.get(url);
  }

  sendEmailInvite(contacts, purchase_id) {
    const url = environment.main_url + 'pc/invite-purchase-participation';
    const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    return this.http.post(url, {
      contacts: contacts,
      purchase_id: purchase_id
    }, httpOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/participate.service.ts